import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
const STEPS = [{
  icon: '📂',
  text: 'Abrís el material',
  desc: 'Acceso inmediato al contenido digital'
}, {
  icon: '🌿',
  text: 'Comprendés la energía',
  desc: 'Teoría clara sin complicaciones'
}, {
  icon: '👐',
  text: 'Practicás con claridad',
  desc: 'Ejercicios guiados paso a paso'
}, {
  icon: '💫',
  text: 'Integrás Reiki a tu vida',
  desc: 'Transformación real y duradera'
}];
export function SolutionSection() {
  return <section className="bg-gray-900 text-white py-24 md:py-32 px-4 relative overflow-hidden" data-id="element-247">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-248"></div>

      <div className="container mx-auto max-w-5xl text-center relative z-10" data-id="element-249">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-250">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-amber-500/30 bg-amber-500/10 text-amber-400 text-sm font-medium mb-6" data-id="element-251">
            <Sparkles className="w-4 h-4" data-id="element-252" /> El Camino del Reiki
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-253">
            MegaPack Reiki
            <br className="hidden md:block" data-id="element-254" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200" data-id="element-255">
              Formación Completa
            </span>
          </h2>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-gray-400 mb-0 leading-relaxed max-w-2xl mx-auto" data-id="element-256">
            Un sistema paso a paso para que cualquier persona pueda iniciarse en
            Reiki con seguridad, integrar la energía a su vida y avanzar con
            confianza.
          </motion.p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-20 relative" data-id="element-257">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-amber-500/30 to-transparent -z-10" data-id="element-258"></div>

          {STEPS.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} whileHover={{
          y: -5
        }} className="group relative bg-gray-800/40 backdrop-blur-sm border border-white/5 hover:border-amber-500/30 rounded-3xl p-6 text-center transition-all duration-300" data-id="element-259">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 text-6xl font-bold text-white/5 select-none pointer-events-none font-serif" data-id="element-260">
                0{idx + 1}
              </div>

              <div className="w-16 h-16 mx-auto bg-gray-800 rounded-2xl flex items-center justify-center text-3xl mb-4 shadow-lg group-hover:shadow-amber-500/20 group-hover:scale-110 transition-all duration-300 border border-white/10" data-id="element-261">
                {step.icon}
              </div>

              <h3 className="font-serif font-bold text-white text-lg mb-2 group-hover:text-amber-400 transition-colors" data-id="element-262">
                {step.text}
              </h3>
              <p className="text-sm text-gray-500 leading-snug" data-id="element-263">{step.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-gray-800/50 to-transparent p-8 rounded-3xl border border-white/5 max-w-3xl mx-auto" data-id="element-264">
          <p className="text-xl md:text-2xl font-bold text-amber-100 mb-8 font-serif" data-id="element-265">
            "Sin improvisar. Sin dudas. Sin confusión."
          </p>

          <motion.a href={HOTMART} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center gap-2 px-10 py-5 bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black font-extrabold text-xl rounded-full shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_50px_rgba(245,158,11,0.6)] transition-all" data-id="element-266">
            👉 QUIERO EMPEZAR AHORA
            <ArrowRight className="w-5 h-5" data-id="element-267" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}